export default {
  tipsOne:
    '1. Guardaremos seus produtos gratuitamente por 90 dias. Se após 90 dias você ainda não enviou a guia de remessa do pacote ou não deu nenhum feedback, será considerado abandono de produtos, e faremos tratamento de destruição unificado dos produtos.',
  tipsTwo:
    '2. Os produtos já foram colocados no armazém, você pode entrar no meu armazém a qualquer momento e enviar para seu endereço de entrega no exterior',
  orderDetail: 'Detalhes do pedido',
  orderNo: 'Número do pedido',
  orderConsult: 'Consulta de pedido',
  consult: 'Consultar',
  orderConsultTips:
    'O comprador só pode lidar com negócios relacionados a este pedido, para outras consultas de negócios, entre em contato',
  enquiryReplyMsg:
    'Digite aqui, responderemos em 24 horas. (Nota: Às vezes usamos software de tradução para responder, pode não transmitir o significado com precisão, esperamos sua compreensão)',
  stepListEnum: {
    '-1': 'Selecionar produtos',
    0: 'Enviar pacote',
    6: 'Pagar frete',
    9: 'Enviar pacote',
    20: 'Confirmar recebimento',
  },
}
